export default {
	lang: 'ru',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav":"ВОРМОР ИИ",
		"nav2":"Безопасность аккаунта",
		"nav3":"Мой облачный диск",
		"nav4":"Выйти",
		"nav5":"Авторизоваться",
		"nav6":"Облачное пространство",
		"nav7":"Большая модель ChatGPT",
		"nav8":"Умный диктофон Cloud Space System",
		"nav_phone_number_code":'номер телефона',
		"nav_update":'замена',
		"nav_bind":'привязка',
		"nav_phone_code_tips":'Для подтверждения, что это вы осуществляете операцию, пожалуйста, завершите проверку личности с помощью SMS-кода',
		"nav_phone_number":'телефонный номер',
		"nav_phone_number_verify":'Переключить проверку номера телефона',
		"nav_phone_email_verify":'Переключить проверку электронной почты',
		"nav_set_phone_number":'Установить новый номер телефона',
		"nav_verify_login":'Проверить вход',
		"nav_phone_email":'Электронная почта/номер телефона',
		"nav_phone_login":'Вход с подтверждением по телефону',
		"nav_email_login":'Вход с проверкой почты',
		"nav_email_fail":'Неверный формат электронной почты, пожалуйста, введите заново',
		"nav_pw_fail":'Неверный формат пароля, пожалуйста, введите заново',
		"nav_code_fail":'Неверный код проверки',
		"nav_phone_fail":'Неверный формат номера телефона, введите, пожалуйста, заново',
		"nav_input_fail":'Пожалуйста, введите электронную почту',
		"nav_input_phone":'Введите номер телефона',
		"nav_phone_verify_back":'Восстановление по SMS',
		"nav_email_verify_back":'Восстановление по электронной почте'
	},
	login: {
		"login1":"Пароль входа",
		"login2":"вход по СМС",
		"loginTab3":"Вход по электронной почте",
		"login3":"Почта",
		"login4":"Логин Пароль",
		"login5":"Номер телефона",
		"login6":"Пожалуйста, выберите",
		"login7":"Мобильный код подтверждения",
		"login8":"Авторизоваться",
		"login9":"забыл пароль",
		"login10":"регистр",
		"login11":"Входя в систему, вы соглашаетесь",
		"login12":"Соглашение об обслуживании",
		"login13":"политика конфиденциальности",
		"login14":"Получать",
		"login15":"Китай",
		"login16":"Пожалуйста, введите номер вашего счета",
		"login17":"Пожалуйста, введите ваш пароль",
		"login18":"Вход успешный!",
		"login19":"Пожалуйста, введите проверочный код!",
		"login20":"Отправлено успешно!",
		"login21":"и",
		"login22":"облачный диск диктофона",
		"login23":"Мое письмо",
		"login24":"Мой разговор",
		"login25":"Безопасность аккаунта",
		"login26":"Выйти",
		"login27":"Получить пароль по электронной почте",
		"login28":"Почта",
		"login29":"Код подтверждения электронной почты",
		"login30":"Установите пароль для входа (6-16 символов)",
		"login31":"Введите пароль еще раз.",
		"login32":"представлять на рассмотрение",
		"login33":"Вернуться к входу",
		"login34":"Модификация выполнена успешно!",
	},
	register: {
		"register1":"Номер телефона",
		"register2":"Пожалуйста, введите ваш номер телефона",
		"register3":"Пожалуйста, выберите",
		"register4":"Мобильный код подтверждения",
		"register5":"Установить пароль",
		"register6":"Пожалуйста, введите проверочный код",
		"register7":"6-16 символов",
		"register8":"Подтверждение пароля",
		"register9":"Почта",
		"register10":"Пожалуйста, введите ваш адрес электронной почты",
		"register11":"Код подтверждения электронной почты",
		"register12":"Пожалуйста, введите проверочный код",
		"register13":"Я прочитал и согласен",
		"register14":"Пожалуйста, прочитайте и отметьте галочкой пункт о согласии с соглашением",
		"register15":"Неверный формат номера телефона/номер телефона зарегистрирован",
		"register16":"Ошибка мобильного проверочного кода",
		"register17":"Пожалуйста, введите свой адрес электронной почты / Формат адреса электронной почты неверен",
		"register18":"Ошибка формата электронной почты",
		"register19":"Ошибка кода подтверждения электронной почты",
		"register20":"Пожалуйста, установите пароль длиной 6–16 символов.",
		"register21":"Ошибка формата пароля",
		"register22":"Пароли, введённые дважды, не совпадают. Введите их ещё раз.",
		"register23":"Пожалуйста, введите ваш пароль",
		"register24":"Регистрация прошла успешно!",
		"register25":"Ошибка проверочного кода",
	},
	recorder:{
		"recorder1":"облачный диск диктофона",
		"recorder2":"Емкость облачного пространства",
		"recorder3":"документ",
		"recorder331":"Мусорная корзина",
		"recorder332":"Очистить все",
		"recorder4":"имя",
		"recorder5":"Длительность аудио",
		"recorder6":"Размер файла",
		"recorder7":"Время создания",
		"recorder8":"работать",
		"recorder9":"Описание облачного пространства",
		"recorder10":"документ",
		"recorder11":"OCR-файл",
		"recorder12":'1. Назначение облачного хранилища',
		"recorder13": "После сохранения записей и рукописных заметок на умных офисных планшетах или диктофонах вы можете загрузить их в облачное хранилище. Это позволит вам просматривать файлы заметок в облаке, даже если умное устройство с вами нет.",
		"recorder14":'2. Как загрузить в облачное хранилище?',
		"recorder15":'Записывающее устройство: Войдите в раздел "Мои файлы" на устройстве → Нажмите "Массовые операции" → Нажмите "Загрузить", чтобы добавить файл в очередь облачной загрузки и перенести его в облачное хранилище.',
		"recorder16": 'Умная офисная тетрадь:',
		"recorder17": 'Способ 1: Доложно нажимайте на списке заметок, чтобы выделить нужные для загрузки → Нажмите "Синхронизировать" для завершения загрузки',
		"recorder171":'Способ 2: Откройте страницу с подробной информацией о заметке → Нажмите на кнопку [Ещё - Синхронизация], чтобы загрузить заметку в облачное хранилище.',
		"recorder18":"Не транскрибировано",
		"recorder19":"Просмотреть сводку",
		"recorder20":"Спикер",
		"recorder21":"Изменить имя докладчика",
		"recorder22":"Конечно",
		"recorder23":"скачать",
		"recorder24":"Загрузить контент:",
		"recorder25":"Настройки загрузки:",
		"recorder26":"Показать спикера",
		"recorder27":"Отмена",
		"recorder28":"Обмен ссылками",
		"recorder29":"Доступ к нему получит любой, кто получит ссылку. Ссылка предназначена только для чтения и действительна в течение 7 дней.",
		"recorder30":"Копировать ссылку",
		"recorder31":"Сканировать и быстро просматривать",
		"recorder32":"Умная организация",
		"recorder33":"Различать говорящих",
		"recorder34":"Разумно различать транскрибированный текст в соответствии с ролью говорящего",
		"recorder35":"Интеллектуальная регуляризация разговорной речи",
		"recorder36":"Автоматически фильтровать модальные частицы, повторяющиеся слова и слова с паузами",
		"recorder37":"Невокальная фильтрация",
		"recorder38":"Автоматически пропускать аудио без голоса или шума во время воспроизведения",
		"recorder39":"Пожалуйста, выберите",
		"recorder40":"документ",
		"recorder41":"Аудио",
		"recorder42":"Документы + Аудио",
		"recorder43":"намекать",
		"recorder44":"Эта операция удалит файлы. Хотите продолжить?",
		"recorder441":"Эта операция удалит все файлы. Хотите продолжить?",
		"recorder45":"Конечно",
		"recorder46":"Отмена",
		"recorder47":"Успешно удалено!",
		"recorder48":"Восстановлено",
		"recorder49":"Теги пока отсутствуют",
		"recorder50":"Сохранение...",
		"recorder51":"Мусорная корзина",
	},
	personal: {
		"personal1":"Настройки учетной записи",
		"personal2":"персональная информация",
		"personal3":"аватар",
		"personal4":"Загрузить файлы",
		"personal5":"Поддержка стилей JPG, JPEG, GIF, PNG, поддержка изображений размером до 2 МБ",
		"personal6":"Псевдоним",
		"personal7":"Пожалуйста, введите ваш псевдоним",
		"personal8":"пол",
		"personal9":"господа",
		"personal10":"Скучать",
		"personal11":"Конфиденциальность",
		"personal12":"День рождения",
		"personal13":"Пожалуйста, выберите дату вашего рождения",
		"personal14":"Профессия",
		"personal15":"Пожалуйста, выберите вашу профессию",
		"personal16":"Укажите, пожалуйста, вашу профессию (необязательно)",
		"personal17":"нация",
		"personal18":"Пожалуйста, выберите вашу страну",
		"personal19":"держать",
		"personal20":"персональная информация",
		"personal21":"Безопасность аккаунта",
		"personal22":"Поддерживает только изображения размером до 2 МБ.",
		"personal23":"Загрузка прошла успешно!",
		"personal24":"Модификация выполнена успешно!",
		"personal25":"Безопасность аккаунта",
		"personal26":"Логин Пароль",
		"personal27":"Исправлять",
		"personal28":"Электронная почта",
		"personal29":"заменять",
		"personal30":"Аннулирование аккаунта",
		"personal32":"Вы уверены, что хотите удалить свою учетную запись?",
		"personal33":"После выхода из системы весь контент вашей учетной записи будет удален, поэтому будьте осторожны.",
		"personal34":"Отмена",
		"personal35":"Конечно",
		"personal36":"Аутентификация",
		"personal37":"Чтобы подтвердить, что это делаете именно вы, пройдите проверку личности, отправив нам код подтверждения по электронной почте.",
		"personal38":"Почта",
		"personal39":"Проверочный код",
		"personal40":"Пожалуйста, введите проверочный код",
		"personal41":"Следующий шаг",
		"personal42":"Настройте новый почтовый ящик",
		"personal43":"Почта",
		"personal44":"Пожалуйста, введите новый адрес электронной почты",
		"personal45":"Проверочный код",
		"personal46":"Пожалуйста, введите проверочный код",
		"personal47":"Конечно",
		"personal48":"Установите новый пароль для входа",
		"personal49":"Новый пароль для входа",
		"personal50":"Пожалуйста, введите новый пароль",
		"personal51":"Подтвердите новый пароль",
		"personal52":"Пожалуйста, введите новый пароль еще раз.",
		"personal53":"Конечно",
		"personal54":"Получать",
		"personal55":"Ошибка формата электронной почты",
		"personal56":"Замена прошла успешно!",
		"personal57":"Пожалуйста, установите пароль длиной 6–16 символов.",
		"personal58":"Пароли, которые вы ввели дважды, не совпадают.",
		"personal59":"Модификация выполнена успешно!",
		"personal60":"Выход из системы успешен!",
		
		"share_url": "Ссылка для общего доступа",
		"share_url_7_day": "Ссылка для общего доступа действительна в течение 7 дней. До истечения срока действия доступ к ней получит любой, кто получит ссылку.",
		"share_audio": "Аудиозапись",
		"share_trans_text": "Транскрипция",
		"share_summny_text": "Краткое содержание",
		"share_map": "Ментальная карта",
		"share_url_pw": "Шифрование доступа",
		"share_random_pw": "Пароль сгенерирован случайным образом",
		"share_url_copy": "Копировать ссылку",
		"share_url_copy_success": "Скопировать ссылку успешно",
		"share_link_pw": "Пароль доступа",
		"share_copy_success": "Транскрипция скопирована в буфер обмена!",
		"share_copy_success2": "Копирование резюме на лист вырезания!",
		"share_speaker": "Выступающий",
		"share_no_update_speaker": "Невозможно изменить Выступающий пусто",
		"share_no_trans":"Нет транскрипции",
		"share_no_summny":"Нет краткого содержания",
		"share_no_map":"Нет содержимого карты",
		"share_trans_text_1": "Транскрипция",
		"share_summny_text_1": "Краткое содержание",
		"share_map_1": "Карта",
		"share_save": "Сохранить успешно",
		"share_no_map":"Изображение карты не создано",
		"share_update_text": "Изменить текст транскрипции",
		"share_update_text2": "Редактировать текст резюме",
		"showLoading": "загрузка...",
		"handwriting": "Рукописный контент",
		"handwritingText": "Рукописный текст",
		"share_1": "Рукописный текст на этой странице не распознан",
		"share_2": "Изменить распознавание рукописного текста",
		"share_3": "Распознавание рукописного текста",
		"share_4":"Экспортирует файл, не покидайте эту страницуี้",
		"folder_text":"Папка",
		"folder_text_update_name":"Переименовать",
		"folder_text_del":"Удалить",
		"folder_text_all":"Все",
		"folder_text_type":"Тип файла",
		"folder_text_audio":"Аудиозаметки",
		"folder_text_writing":"Рукописные заметки",
		"folder_text_file_type":"Тип файла",
		"folder_text_add":"Создать новую папку",
		"folder_text_input_name":"Введите имя",
		"folder_text_cancel":"Отмена",
		"folder_text_summit":"Подтвердить",
		"folder_text_name_not_null":"Имя не может быть пустым",
		"folder_text_add_success":"Создано Успешно!",
		"folder_text_del_confirm":"Удаление подтверждено",
		"folder_text_confirm":"Вы уверены, что хотите удалить выбранную папку? Заметки в папке будут перемещены в корзину после удаления.",
		"folder_text_del_success":"Удалено успешно!",
		"folder_text_move":"Перемещено в",
		"folder_text_move_success":"Успешно перемещено!",
		"folder_update_name":"Папка переименована",
		"folder_text_update_success":"Изменено успешно!",
		"empty_text":"Данные отсутствуют.",
		"trans_text_null":"Расшифрованный текст не может быть пустым",
		"summary_text_null":"Краткое содержание не может быть пустым",
		"please_create_folder":"Сначала создайте папку."
	}
}